import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAdminAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            toast.error("Renseignez votre identifiant et mot de passe.");
            return;
        }
        setLoading(true);
        try {
            await login({ username, password });
            toast.success("Connexion réussie.");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error("Identifiants invalides.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-6">
            <div className="w-full max-w-md bg-white rounded-2xl border border-neutral-200 p-8 shadow-sm">
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 rounded-xl bg-[#1C1C1E] flex items-center justify-center">
                        <Lock className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h1 className="font-display text-xl font-semibold tracking-tight">
                            Administration
                        </h1>
                        <p className="text-sm text-neutral-500">Atelier AX CMS</p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-1.5">
                        <Label className="text-sm">Identifiant</Label>
                        <Input
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="admin"
                            autoComplete="username"
                        />
                    </div>
                    <div className="space-y-1.5">
                        <Label className="text-sm">Mot de passe</Label>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </div>
                    <Button
                        type="submit"
                        disabled={loading}
                        className="w-full rounded-full bg-[#1C1C1E] hover:bg-black"
                    >
                        {loading ? (
                            <Loader2 className="w-4 h-4 animate-spin mr-2" />
                        ) : null}
                        Se connecter
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;
